import {
    createContext, useContext, Dispatch, SetStateAction,
} from 'react'

export type ContractBasisCreateQuoteContextType = {
    activeStep: number,
    setActiveStep: Dispatch<SetStateAction<number>>,
    quoteId?: number,
    contractBasisId: number,
}

export const ContractBasisCreateQuoteContext = createContext<
    ContractBasisCreateQuoteContextType
>(null)

const useContractBasisCreateQuoteContext = () => {
    return useContext<ContractBasisCreateQuoteContextType>(ContractBasisCreateQuoteContext)
}

export default useContractBasisCreateQuoteContext
